module.exports = __webpack_public_path__ + "static/media/logo-en_toute_intimite-blue.c43cdc30.svg";